import { Rgb } from "./types";

export const FONT = "monospace";

export const PALETTE = {
    background: [12, 14, 22],
    white: [255, 255, 255],
    gold: [255, 215, 30],
    mutedText: [150, 160, 180],
    buttonText: [20, 20, 25],
    accent: [45, 140, 255],
} satisfies Record<string, Rgb>;

export function textStyle(size: number) {
    return { size, font: FONT };
}
